import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { MarketingSite } from "@/components/site/MarketingSite";
import { ProgramDetail } from "@/components/site/ProgramDetail";
import { PrivacyPolicy, TermsConditions } from "@/components/site/Legal";
import { AdminLogin } from "@/components/admin/AdminLogin";
import { AdminDashboard } from "@/components/admin/AdminDashboard";

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors closeButton
        toastOptions={{ style: { fontFamily: "'Inter', sans-serif" } }} />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MarketingSite />} />
          <Route path="/programs/:slug" element={<ProgramDetail />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsConditions />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
